import request from "_private/utils/request";

/**
 * @description 新增和修改组织架构信息
 * @author sunxiaodong
 * @export
 * @param {*} data
 * @returns
 */
export function FetchSaveOrganization(data) {
    return request({
        url: "/base/organization/saveOrganization",
        method: "post",
        data
    });
}

/**
 * @description 获取组织架构详情
 * @author sunxiaodong
 * @export
 * @param {*} data
 * @returns
 */
export function FetchFindOrganizationDetail(data) {
    return request({
        url: "/base/organization/findOrganizationDetail",
        method: "post",
        data
    });
}

/**
 * @description 删除组织架构
 * @author sunxiaodong
 * @export
 * @param {*} data
 * @returns
 */
export function FetchDeleteOrganizationByOrgId(data) {
    return request({
        url: "/base/organization/deleteOrganizationByOrgId",
        method: "post",
        data
    });
}

/**
 * @description 获取部门管理基础信息扩展字段
 * @author sunxiaodong
 * @export
 * @param {*} data
 * @returns
 */
export function FetchGetExtColumn(data) {
    return request({
        url: "/base/organization/getExtColumn",
        method: "post",
        data
    });
}

/**
 * @description 根据部门ordId获取部门子集
 * @author sunxiaodong
 * @export
 * @param {*} data
 * @returns
 */
export function FetchFindOrganizationAndUserTreeByOrgId(data) {
    return request({
        url: "/base/user/findOrganizationAndUserTreeByOrgId",
        method: "post",
        data
    });
}

/**
 * @description 根据用户orgId获取用户信息
 * @author sunxiaodong
 * @export
 * @param {*} data
 * @returns
 */
export function FetchFindOrganizationAndUserVOByUserId(data) {
    return request({
        url: "/base/user/findOrganizationAndUserVOByUserId",
        method: "post",
        data
    });
}

/**
 * @description 修改用户信息
 * @author sunxiaodong
 * @export
 * @param {*} data
 * @returns
 */
export function FetchUpdateUserOrgId(data) {
    return request({
        url: "/base/user/updateUserOrgId",
        method: "post",
        data
    });
}
